import {
    Component, Mixins, Emit,
} from 'vue-property-decorator';
import SlideUpDown from 'vue-slide-up-down';
import { YIcon } from '@components/index';
import Hybrid from '@components/shared/mixins/hybrid';
import Classes from '@components/shared/mixins/classes';
import config from '@components/shared/config';
import Props from './props';

/**
 * @name Panel
 */
@Component({
    components: {
        SlideUpDown,
        YIcon,
    },
})
class YPanel extends Mixins(Hybrid, Props, Classes) {
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['icon', 'sharp', 'rounded', 'flat', 'raised', 'dense'];

    /**
     * The css parent class of the component
     */
    parentClass: string = this.componentClass(this.baseClass, config.prefix.panel);

    collapseClass: string = 'is-open';
    isPanelOpened: boolean = !this.getBoolean('collapsed') || false;

    /**
     * Create Common Props for the panel.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> {
        const commonProps: Record<string, any> = {
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            if (this.element && this.element[item]) {
                commonProps[item] = this.element[item];
            } else {
                commonProps[item] = this[item];
            }
        });
        return commonProps;
    }

    /**
     * Create classes array for the panel.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Panel', this.commonProps, this.baseClass || config.prefix.panel));
        if (this.noPadding) {
            cls.push('has-no-padding');
        }
        return cls;
    }

    /**
     * Check panel is open
     * 
     * @returns {boolean}
     */
    get isOpen(): Boolean {
        return this.isPanelOpened;
    }

    /**
     * Checks if header slot exists
     *
     * @returns {boolean}
     */
    get hasHeader(): boolean {
        return (this.getBoolean('title')
                    || this.getBoolean('subtitle')
                    || this.getBoolean('icon')
                    || !!(this.$slots.header)
        );
    }

    /**
     * Checks if header slot exists
     *
     * @returns {boolean}
     */
    get hasFooter(): boolean {
        return !!(this.$slots.footer);
    }

    /**
     * Body Tag
     * 
     * @returns {string}
     */
    get bodyTag(): string {
        return this.getBoolean('collapsible') ? 'slide-up-down' : 'div';
    }

    /**
     * Open Panel
     */
    @Emit('open')
    open() {
        this.collapseClass = 'is-open';
        this.isPanelOpened = true;
    }

    /**
     * Close Panel
     */
    @Emit('close')
    close() {
        this.collapseClass = 'is-close';
        this.isPanelOpened = false;
    }

    /**
     * Toggle panel
     */
    togglePanel() {
        if (!this.isOpen) {
            this.open();
        } else {
            this.close();
        }
    }
}

export default YPanel;
